import { useTranslation } from "react-i18next";

import "./notification.scss";
import { Breadcrumb, Button, Collapse, Form, List, Switch } from "antd";
import { _adr } from "../../address";
import { DownOutlined, HomeOutlined, UpOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAPIPublic, useDealer } from "../../tools/api";
import { base64ToFile, convertToJalaliWithoutTime, formatTime } from "../../tools/tools";
import { NotFound } from "../../sources/svg/svg";
import Item from "./item";

const Notification = () => {
	const [t] = useTranslation("global");

	const { Panel } = Collapse;

	const { queryAnnouncementGroupByPlanId, queryAnnouncementDealerByState, createAnnouncementsVUser } = useDealer();
	const { getDocument } = useAPIPublic();
	const [tabGroup, setTabGroup] = useState([]);
	const [selected, setSelected] = useState(0);
	const [expandedItems, setExpandedItems] = useState({});

	const [loadDetail, setLoadDetail] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	//state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	const [totalRecord, setTotalRecord] = useState(0);
	const [isRead, setIsRead] = useState(true);

	const [selectedGp, setSelectedGp] = useState("1");

	// useEffect(() => {
	// 	const initialLoadTabContent = async () => {
	// 		let payload = {
	// 			planid: process.env.REACT_APP_PLANID_NOTIFICATION,
	// 		};
	// 		let response = await queryAnnouncementGroupByPlanId(payload);
	// 		if (response) {
	// 			if (response.length > 0) {
	// 				setSelected(response[0].announcementGroupId);
	// 				setTabGroup(response);
	// 			}
	// 		}
	// 	};
	// 	initialLoadTabContent();
	// }, []);

	const handleClick = (index) => {
		setSelected(index);
		const element = document.getElementById(`tab-${index}`);
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
		}
	};

	useEffect(() => {
		getNotification();
	}, [selected, isRead]);

	const getNotification = async () => {
		if (selected !== 0) {
			let payload = {
				announcementgroupid: selected,
				isread: isRead,
				search: {
					sort: "",
					filter: "",
					entriesperpage: 10,
					page: currentPage,
					totalrowcount: totalRecord,
				},
			};
			let response = await queryAnnouncementDealerByState(payload);
			if (response && response?.Result) {
				setLoadDetail(response?.Result || []);
				setTotalRecord(response.searchconfigmodel.totalrowcount);
			}
		}
	};

	const handleCollapse = (key) => {
		setExpandedItems((prevExpandedItems) => {
			return { ...prevExpandedItems, [key]: !prevExpandedItems[key] };
		});
	};

	const handleDownload = async (item, announcementGroupId) => {
		let response = await getDocument(item);
		if (response) {
			handleReadNotification(announcementGroupId);
			const url = window.URL.createObjectURL(await base64ToFile(response));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "file.jpg");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		}
	};
	const handleReadNotification = async (announcementGroupId) => {
		let payload = {
			announcementid: announcementGroupId,
		};
		let response = await createAnnouncementsVUser(payload);
		if (response) {
		}
	};
	return (
		<>
			<div className="container-main container-na">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("notification.title") }]}
						/>
						<div className="title-page">
							<h3>{t("notification.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main na-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="container-notification">
									<div className="header-notification">
										<div className="row-header">
											<div className="holder-categories">
												{/* <div className="row-item">
													{tabGroup?.map((tab, index) => (
														<div
															key={index}
															id={`tab-${tab.announcementGroupId}`}
															className={`item ${tab.announcementGroupId === selected ? "active" : ""}`}
															onClick={() => handleClick(tab.announcementGroupId)}
															data-id={tab.announcementGroupId}>
															{tab.groupName}
														</div>
													))}
												</div> */}
												<div className="row-item">
													<div
														id={`tab-1`}
														className={`item ${"1" === selectedGp ? "active" : ""}`}
														onClick={() => setSelectedGp("1")}
														data-id={"tab.announcementGroupId"}>
														منابع آموزشی
													</div>
													<div
														id={`tab-1`}
														className={`item ${"2" === selected ? "active" : ""}`}
														onClick={() => setSelectedGp("2")}
														data-id={"tab.announcementGroupId"}>
														اطلاعیه ها
													</div>
												</div>
											</div>
											<div className="holder-unread">
												{/* <Form.Item className="input-normal" label="پیام‌های خوانده نشده">
													<Switch
														defaultChecked
														onChange={(e) => {
															setIsRead(e);
														}}
													/>
												</Form.Item> */}
											</div>
										</div>
									</div>
									<div className="body-notification">
										<div className="show-list">
											{selectedGp == "1" && (
												<>
													{/* <Item title="طرح تشویقی تسهیم درآمد از فروش بسته های اینترنتی " path="/assets/files/RevenueShare.pdf" /> */}
													<Item title="راهنمای استفاده از سرویس آسان بیمه" path="/assets/files/Aptel-X-Bimeh-Guideline-V1.pdf" />
													<Item title="راهنمای استفاده از سرویس تغییرمالکیت مشترکین" path="/assets/files/change-ownership.pdf" />
													<Item title="راهنمای استفاده از سرویس 360 مشترکین" path="/assets/files/360-Guideline-‌Final.pdf" />
													<Item title="فایل آموزشی طرح تحویل حضوری " path="/assets/files/delivery-person.pdf" />
													<Item title="تعویض سیم کارت " path="/assets/files/change-sim.pdf" />
													<Item title="ثبت نام حقیقی " path="/assets/files/sim-legal.pdf" />
													<Item title="خرید بسته و شارژ " path="/assets/files/dc-ep.pdf" />
												</>
											)}
											{selectedGp == "2" && (
												<>
													<Item title=" جشنواره اردیبهشت و خرداد ماه 1405" path="/assets/files/جشنواره-اردیبهشت-و-خرداد-1405.pdf" />
													<Item title=" نحوه بارگذاری صحیح مدارک  " path="/assets/files/نحوه-بارگذاری-صحیح-مدارک.pdf" />
													<Item title=" ارتباط با پشتیبانی نمایندگان  " path="/assets/files/اطلاعیه-ارتباط-24-ساعته-با-پشتیبانی-نمایندگان.pdf" />
													<Item title=" بروشور جدید " path="/assets/files/بروشور-جدید.pdf" />
													<Item title="لیست تعرفه فروش سیم کارت- تیر 1405" path="/assets/files/لیست-تعرفه-فروش-سیم-کارت-خرداد-1405.pdf" />
													<Item title=" اطلاع رسانی سقف مجاز و تخلفات ارسال پیامک از سیم‌کارت مشترکین " path="/assets/files/top-sms.pdf" />
													<Item title="اطلاعیه اصلاح مدارک تغییر مالکیت" path="/assets/files/اطلاعیه-اصلاح-مدارک-تغییر-مالکیت-1404.02.13.pdf" />
													{/* <Item title="طرح تشویقی تسهیم درآمد از فروش بسته‌های اینترنتی" path="/assets/files/NE140407214.pdf" /> */}
													<Item title="تعرفه سرویس ها و خدمات آپتل جدید" path="/assets/files/تعرفه-سرویس-ها-و-خدمات-آپتل.pdf" />
												</>
											)}

											{/* <List
												itemLayout="horizontal"
												size="large"
												dataSource={loadDetail}
												pagination={{
													className: "page-pagination",
													onChange: (page) => {
														setCurrentPage(page);
													},
													pageSize: 10,
													align: "start",
													current: currentPage === 0 ? 1 : currentPage,
													total: totalRecord,
													showSizeChanger: false,
												}}
												className="show-list"
												loading={isLoading}
												locale={{ emptyText: <NotFound text={""} /> }}
												renderItem={(item, key) => (
													<div className={`item ${!item.isactive ? "read" : ""}`} key={key}>
														<div className="row-item">
															<div className="holder-icon">
																<div className="box-icon">
																	<i className="icon-post-box"></i>
																</div>
															</div>
															<div className="holder-title-notifi">
																<span className="date-category">
																	اخبار آپتل{" "}
																	<span dir="ltr">
																		{convertToJalaliWithoutTime(item.operationDate)} - {formatTime(new Date(item.operationDate))}
																	</span>
																</span>
																<div className="show-title">
																	<h3>{item.title}</h3>
																</div>
															</div>
															<div className="holder-action">
																{item.documentid && (
																	<div className="holder-button">
																		<Button
																			onClick={() => {
																				handleDownload(item.documentid, item.announcementid);
																			}}
																			className="btn-normal btn-nrm">
																			دانلود فایل
																		</Button>
																	</div>
																)}

																<div className="holder-show-more">
																	<div
																		onClick={() => {
																			handleCollapse(key);
																		}}>
																		نمایش اطلاعات
																		{!expandedItems[key] ? <UpOutlined /> : <DownOutlined />}
																	</div>
																</div>
															</div>
														</div>
														<div className="holder-collapse">
															{expandedItems[key] && (
																<div className="collapse-item">
																	<Collapse defaultActiveKey={["1"]} ghost accordion={false}>
																		<Panel key="1" showArrow={false}>
																			<div className="holder-content">{item.detail}</div>
																		</Panel>
																	</Collapse>
																</div>
															)}
														</div>
													</div>
												)}
											/> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default Notification;
